import { Box, Flex, Progress, Text } from '@chakra-ui/react';

import PropTypes from 'prop-types';

function ProgressDisplay({
  percentage,
  count,
  countLabel,
  isLoading,
  ...rest
}) {
  return (
    <Box {...rest}>
      <Progress
        my={2}
        size="sm"
        colorScheme={percentage === 100 ? 'green' : 'blue'}
        value={percentage || 0}
        isIndeterminate={isLoading}
        isAnimated
        hasStripe={percentage !== 100}
        borderRadius="5px"
      />

      <Flex mt={6} mb={3} wrap="wrap">
        <Text as="sup" flex={1}>
          {Math.round(percentage)}% Complete
        </Text>

        {count > 0 && (
          <Text as="sup">
            {count} {countLabel}
          </Text>
        )}
      </Flex>
    </Box>
  );
}

ProgressDisplay.defaultProps = {
  countLabel: 'Activities',
};

ProgressDisplay.propTypes = {
  percentage: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  countLabel: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
};

export default ProgressDisplay;
